import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { FormModule } from 'shared/form/form.module';
import { SharedModule } from 'shared/shared.module';

import { AcceptInviteComponent } from './accept-invite.component';
import { AcceptInviteRoutingModule } from './accept-invite-routing.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AcceptInviteRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    FormModule,
  ],
  declarations: [AcceptInviteComponent],
  exports: [AcceptInviteComponent]
})
export class AcceptInviteModule {}
